/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'breakdown': {
    width: 16,
    height: 16,
    viewBox: '0 0 18.63 16.09',
    data: '<g data-name="图层 2"><g data-name="图层 1"><path pid="0" d="M18.13 15.09H15.6L10.9 1.14A1.65 1.65 0 009.32 0a1.66 1.66 0 00-1.59 1.14L3 15.09H.5a.5.5 0 000 1h17.63a.5.5 0 000-1zm-14 0L8.67 1.46a.68.68 0 011.28 0l4.59 13.62z" _fill="#c4c4c4"/><path pid="1" d="M12.09 7.78H6.54l-1.37 4.07h8.29zM10 1.46a.68.68 0 00-1.28 0L7.54 4.81h3.54z" _fill="#74777a"/></g></g>'
  }
})
